import { IAndITimePeriodsValue } from "@/config/date";
import { lensApi } from "@/services/lensApi";
import { StructureFilterParams, getStructureFilterParamsForRequst } from "@/utils/filters";

export interface IAndITotals {
	timePeriod: IAndITimePeriodsValue;
	days: number;
	wasteVolume: number;
	infiltrationVolume: number;
	inflowVolume: number;
	totalVolume: number;
	unit: Dryp.Unit;
	structureIdsMissingConnectivity: Dryp.StructureId[];
}

export const infiltrationAndInflow = {
	getSummaries: async (
		pagination: Dryp.PaginationQuery,
		timePeriod: IAndITimePeriodsValue,
		sort?: Dryp.SortQuery,
		structureFilters?: StructureFilterParams,
	): Promise<Dryp.IAndISummaryList | null> =>
		lensApi.get<Dryp.IAndISummaryList>("/structure-infiltrationAndInflow-summaries", {
			params: {
				...pagination,
				...(sort ? { sort: sort.sort, direction: sort.direction } : {}),
				timePeriod,
				...getStructureFilterParamsForRequst(structureFilters || {}),
			},
		}),

	getTotals: async (
		timePeriod: IAndITimePeriodsValue,
		structureFilters?: StructureFilterParams,
		validated?: boolean,
	): Promise<IAndITotals | null> =>
		lensApi.get<IAndITotals>("/structure-infiltrationAndInflow-summaries/totals", {
			params: {
				timePeriod,
				...(validated !== undefined ? { validated } : {}),
				...getStructureFilterParamsForRequst(structureFilters || {}),
			},
		}),
};
